/* ------------------------------------------------ b9r-localize ---
   Copy is written in USD ("Your $200 golf shoes"). Shoppers outside the US
   see it in their own currency, using Shopify's live rate for the market:

   - [data-b9r-localize="story"] (the advertorial body): story and comparison
     prices, rounded to the kind of number a person would say ("£150", "€180",
     "£450-£900"), never "£154.06".
   - [data-b9r-localize="exact"]: an exact price the server couldn't match to a
     product price (e.g. a price typed into the copy later), formatted like the
     page's own prices.

   Product prices never pass through here; Shopify already prices those per
   market. In the US nothing runs. Safe to run more than once. */
(function () {
  var cur = window.Shopify && window.Shopify.currency;
  if (!cur || !cur.active || cur.active === 'USD') return;
  var rate = parseFloat(cur.rate);
  if (!rate || isNaN(rate)) return;
  var SYMBOL = { GBP: '£', EUR: '€' };
  var sym = SYMBOL[cur.active] || '$';
  var commaDecimals = cur.active === 'EUR';
  var USD = /\$\s?(\d{1,3}(?:,\d{3})+|\d+)(\.\d{1,2})?/g;
  // CAD/AUD/NZD keep the "$", so remember what's been converted already
  var done = typeof WeakSet === 'function' ? new WeakSet() : null;

  function group(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, commaDecimals ? '.' : ','); }

  function story(v) {
    var x = v * rate;
    if (x < 10) return sym + (Math.round(x * 20) / 20).toFixed(2).replace('.', commaDecimals ? ',' : '.');
    if (x < 100) x = Math.round(x / 5) * 5;
    else if (x < 300) x = Math.round(x / 10) * 10;
    else if (x < 1000) x = Math.round(x / 50) * 50;
    else x = Math.round(x / 50) * 50;
    return sym + group(x);
  }

  function exact(v) {
    var c = Math.round(v * rate * 100);
    var whole = group(Math.floor(c / 100));
    return sym + whole + (commaDecimals ? ',' : '.') + ('0' + (c % 100)).slice(-2);
  }

  // the mode of the nearest [data-b9r-localize] around a node, or null outside one
  function modeOf(el) {
    var root = el && el.closest && el.closest('[data-b9r-localize]');
    if (!root) return null;
    return root.getAttribute('data-b9r-localize') === 'exact' ? exact : story;
  }

  function convert(node, mode) {
    var p = node.parentNode;
    if (!p || /^(SCRIPT|STYLE|NOSCRIPT)$/.test(p.nodeName)) return;
    if (done && done.has(node)) return;
    var t = node.nodeValue;
    if (!t || t.indexOf('$') === -1) return;
    if (p.closest && p.closest('[data-b9r-noloc]')) return;
    mode = mode || modeOf(p);
    if (!mode) return;
    node.nodeValue = t.replace(USD, function (m, whole, dec) {
      return mode(parseFloat(whole.replace(/,/g, '') + (dec || '')));
    });
    if (done) done.add(node);
  }

  function walk(root, mode) {
    if (root.nodeType === 3) { convert(root, mode); return; }
    if (root.nodeType !== 1 || (root.textContent || '').indexOf('$') === -1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) convert(node, mode);
  }

  function run() {
    document.querySelectorAll('[data-b9r-localize]').forEach(function (root) {
      walk(root, root.getAttribute('data-b9r-localize') === 'exact' ? exact : story);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // page builders that render late (the advertorial's carousels) get a second pass,
  // and screens drawn later (each quiz step) are converted as they appear.
  // Only what changed is read again: re-reading the whole page on every
  // change (a countdown ticks each second) cost the advertorial ~1.7s of CPU.
  window.addEventListener('load', function () { window.setTimeout(run, 300); });
  if ('MutationObserver' in window) {
    var pending = [];
    new MutationObserver(function (records) {
      if (!pending.length) window.requestAnimationFrame(function () {
        var batch = pending; pending = [];
        batch.forEach(function (n) { if (n.isConnected !== false) walk(n); });
      });
      records.forEach(function (r) {
        if (r.type === 'characterData') pending.push(r.target);
        else for (var i = 0; i < r.addedNodes.length; i++) pending.push(r.addedNodes[i]);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
